import { render } from "./CardEditorView.vue?vue&type=template&id=0725b44b&scoped=true"
import script from "./CardEditorView.vue?vue&type=script&lang=js"
export * from "./CardEditorView.vue?vue&type=script&lang=js"

import "./CardEditorView.vue?vue&type=style&index=0&id=0725b44b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0725b44b"]])

export default __exports__